/**
 * リクエストファイルアップロード時の確認ダイアログ(予約APIをDryRunモードで実行)
 * -API自体がエラーで返ってくる場合
 * リクエストファイルアップロード後のエラーダイアログ(予約APIを通常モードで実行)
 * -API自体がエラーで返ってくる場合
 * アクティベーションファイルのダウンロード後のエラーダイアログ
 */

import { Button, Popup, Title } from 'common/components';
import { BoardGL, Glossary } from 'common/utils/glossary';

// DEVICE_ACTIVATE_API_ERROR_COMPLETION_DISP

interface BoardProps {
  /** ApiErrorCompletionBoardの表示有無 */
  isDisplay: boolean;
  /** グロッサリ */
  glossary: Glossary;
  /** ダイアログに表示するメッセージ */
  apiErrorMessage: string;
  /** 閉じるボタン(OK)の処理 */
  onClickClose: () => void;
}

export const ApiErrorCompletionBoard: React.FC<BoardProps> = ({
  isDisplay,
  glossary,
  apiErrorMessage,
  onClickClose
}) => {
  const _component = (
    <Popup
      className="apiErrorCompletionBoard-popup"
      onClickBackground={onClickClose}
      data-test="apiErrorCompletionBoard-popup"
      visible={isDisplay}
    >
      <div className="apiErrorCompletionBoard">
        <Title type="title" data-test="apiErrorCompletionBoard">
          <span
            className="errorIcon"
            data-test="apiErrorCompletionBoard-errorIcon"
          />
          <p>{apiErrorMessage}</p>
        </Title>
        <div className="apiErrorCompletionBoard-buttonContainer">
          <Button
            type="cancelButton"
            data-test="apiErrorCompletionBoard-cancelButton"
            onClick={onClickClose}
          >
            {glossary.glx(BoardGL.ActivateBoardOK)}
          </Button>
        </div>
      </div>
    </Popup>
  );
  return isDisplay ? _component : null;
};

export default ApiErrorCompletionBoard;
